import { render } from "./ArchiveBulkCampaignAction.vue?vue&type=template&id=46731528"
import script from "./ArchiveBulkCampaignAction.vue?vue&type=script&lang=ts"
export * from "./ArchiveBulkCampaignAction.vue?vue&type=script&lang=ts"
script.render = render

export default script